<!-- START: Browser chrome -->
<div
  class="da-chrome d-flex flex-row align-items-center justify-content-between"
>
  <i class="bi bi-list da-chrome-icon"></i>
  <span class="da-searchbar"></span>
  <i class="bi bi-search da-chrome-icon"></i>
</div>
<!-- END: Browser chrome -->
